// removed by extract-text-webpack-plugin
module.exports = {"SuggestList":"SuggestList--1vBiY"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/SuggestList/SuggestList.scss
// module id = 956
// module chunks = 1